import { render, staticRenderFns } from "./InputRectangleCoordinatableObjectEditor.vue?vue&type=template&id=5e3695da&scoped=true&"
import script from "./InputRectangleCoordinatableObjectEditor.vue?vue&type=script&lang=ts&"
export * from "./InputRectangleCoordinatableObjectEditor.vue?vue&type=script&lang=ts&"
import style0 from "./InputRectangleCoordinatableObjectEditor.vue?vue&type=style&index=0&id=5e3695da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3695da",
  null
  
)

export default component.exports